export default __webpack_public_path__ + "static/media/nounproject.21bf5f92.webp";